import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/pages/Services";
import { useCollection } from "@/hooks/useCollection";
import { fileUrl } from "@/lib/api";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Calendar, User } from "lucide-react";

export default function News() {
  const { items } = useCollection("news");
  const [active, setActive] = useState(null);
  return (
    <div>
      <PageHeader eyebrow="Berita & Artikel" title="Kabar Terbaru" subtitle="Ikuti perkembangan terbaru, wawasan teknologi, dan kegiatan PT Lotus Lentera." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((n, i) => (
            <Reveal key={n.id} delay={i * 0.06}>
              <button onClick={() => setActive(n)} className="text-left group bg-ll-card rounded-2xl overflow-hidden card-hover gold-border w-full h-full flex flex-col" data-testid={`news-card-${i}`}>
                <div className="h-48 overflow-hidden"><img src={fileUrl(n.image)} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="flex items-center gap-4 text-xs text-white/50 mb-2">
                    <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {n.date}</span>
                    <span className="flex items-center gap-1"><User className="w-3 h-3" /> {n.author}</span>
                  </div>
                  <h3 className="font-syne font-semibold text-lg text-white group-hover:text-gold transition-colors">{n.title}</h3>
                  <p className="text-sm text-white/60 mt-2 flex-1">{n.excerpt}</p>
                  <span className="text-gold text-sm mt-3">Baca selengkapnya →</span>
                </div>
              </button>
            </Reveal>
          ))}
          {items.length === 0 && <p className="text-white/50">Belum ada berita.</p>}
        </div>
      </section>
      <Dialog open={!!active} onOpenChange={() => setActive(null)}>
        <DialogContent className="bg-[#0F1117] border-amber-500/20 text-white max-w-2xl max-h-[85vh] overflow-y-auto">
          {active && (
            <div>
              {active.image && <img src={fileUrl(active.image)} alt={active.title} className="w-full h-56 object-cover rounded-xl mb-4" />}
              <div className="flex items-center gap-4 text-xs text-white/50 mb-2"><span>{active.date}</span><span>· {active.author}</span></div>
              <h2 className="font-syne font-bold text-2xl gold-gradient-text mb-3">{active.title}</h2>
              <p className="text-white/80 leading-relaxed whitespace-pre-line">{active.content || active.excerpt}</p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
